import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { hitApi, dateFormatter, commonToast } from "../../../components/commonAction";
import BillingTabs from "./BillingTabs";

export default function Payouts({ pageTitle }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("requested");
    const [busyId, setBusyId] = useState(null);
    const [markPayoutId, setMarkPayoutId] = useState(null);
    const [paypalTxId, setPaypalTxId] = useState("");
    const [markNotes, setMarkNotes] = useState("");
    const [rejectPayoutId, setRejectPayoutId] = useState(null);
    const [rejectNotes, setRejectNotes] = useState("");

    const load = () => {
        setLoading(true);
        const qs = filter ? `?status=${encodeURIComponent(filter)}` : "";
        hitApi({ url: `admin/billing/payouts${qs}`, method: "GET", data: {}, alert: false }, (resp) => {
            setLoading(false);
            if (resp?.status) setRows(resp.data?.payouts || []);
        });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(load, [filter]);

    const approve = (p) => {
        setBusyId(p._id);
        hitApi({ url: `admin/billing/payouts/${p._id}/approve`, method: "PATCH", data: {}, alert: false }, (resp) => {
            setBusyId(null);
            if (resp?.status) { commonToast("success", resp.message); load(); }
        });
    };
    const submitMarkPaid = () => {
        if (!paypalTxId.trim()) { commonToast("error", "PayPal txn id is required."); return; }
        setBusyId(markPayoutId);
        hitApi(
            { url: `admin/billing/payouts/${markPayoutId}/mark-paid`, method: "PATCH", data: { externalPaypalTxId: paypalTxId, notes: markNotes }, alert: false },
            (resp) => {
                setBusyId(null);
                if (resp?.status) {
                    commonToast("success", resp.message);
                    setMarkPayoutId(null); setPaypalTxId(""); setMarkNotes("");
                    load();
                }
            }
        );
    };
    const submitReject = () => {
        setBusyId(rejectPayoutId);
        hitApi(
            { url: `admin/billing/payouts/${rejectPayoutId}/reject`, method: "PATCH", data: { notes: rejectNotes }, alert: false },
            (resp) => {
                setBusyId(null);
                if (resp?.status) {
                    commonToast("success", resp.message);
                    setRejectPayoutId(null); setRejectNotes("");
                    load();
                }
            }
        );
    };

    return (
        <div className="pxl_rightBar_assets">
            <Helmet><title>{pageTitle}</title></Helmet>
            <div className="pxl-rb-header-wrap"><div className="pxl-headingTop"><h2 className="pxl-rb-header-heading">Billing</h2></div></div>
            <BillingTabs />

            <div className="pxl-panel">
                <div className="pxl-panel-header">
                    <span>Payouts ({rows.length})</span>
                    <select
                        style={{ width: "auto", padding: "6px 10px", borderRadius: 6, border: "1px solid #e3e7f0", fontSize: 13 }}
                        value={filter}
                        onChange={e => setFilter(e.target.value)}
                    >
                        <option value="">All</option>
                        <option value="requested">Requested</option>
                        <option value="approved">Approved</option>
                        <option value="paid">Paid</option>
                        <option value="rejected">Rejected</option>
                    </select>
                </div>
                <div className="pxl-panel-body pxl-panel-body--flush">
                    {!loading && rows.length === 0 ? (
                        <div className="text-muted" style={{ padding: 24, textAlign: "center" }}>No payouts.</div>
                    ) : (
                        <div className="pxl_table table-responsive">
                            <table className="pxl_table">
                                <thead>
                                    <tr>
                                        <th>Requested</th>
                                        <th>Affiliate</th>
                                        <th>Amount</th>
                                        <th>PayPal email</th>
                                        <th>Status</th>
                                        <th>External txn</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <>
                                            {[0, 1, 2, 3, 4].map(i => (
                                                <tr key={i}>
                                                    <td><span className="pxl-sk" style={{ width: '65%', height: 13, display: 'block' }} /></td>
                                                    <td>
                                                        <span className="pxl-sk" style={{ width: '60%', height: 13, display: 'block' }} />
                                                        <span className="pxl-sk" style={{ width: '45%', height: 10, display: 'block', marginTop: 4 }} />
                                                    </td>
                                                    <td><span className="pxl-sk" style={{ width: '45%', height: 13, display: 'block' }} /></td>
                                                    <td><span className="pxl-sk" style={{ width: '65%', height: 13, display: 'block' }} /></td>
                                                    <td><span className="pxl-sk" style={{ width: 60, height: 22, borderRadius: 11, display: 'block' }} /></td>
                                                    <td><span className="pxl-sk" style={{ width: '55%', height: 13, display: 'block' }} /></td>
                                                    <td><span className="pxl-sk" style={{ width: 80, height: 30, borderRadius: 6, display: 'block' }} /></td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : rows.map(r => (
                                        <tr key={r._id}>
                                            <td><p>{dateFormatter(r.requestedAt)}</p></td>
                                            <td>
                                                <p style={{ margin: 0 }}>{r.affiliateUser?.name || "(unknown)"}</p>
                                                <p style={{ color: "#8a8fa6", fontSize: 12, margin: 0 }}>{r.affiliateUser?.email}</p>
                                            </td>
                                            <td><p><strong>{r.currency} {Number(r.amount).toFixed(2)}</strong></p></td>
                                            <td><p style={{ fontSize: 12 }}>{r.paypalEmailSnapshot}</p></td>
                                            <td>
                                                {r.status === "paid"      && <span className="pxl-pill pxl-pill--success">paid</span>}
                                                {r.status === "approved"  && <span className="pxl-pill pxl-pill--info">approved</span>}
                                                {r.status === "requested" && <span className="pxl-pill pxl-pill--muted">requested</span>}
                                                {r.status === "rejected"  && <span className="pxl-pill pxl-pill--danger">rejected</span>}
                                            </td>
                                            <td><p style={{ fontFamily: "ui-monospace, Menlo, monospace", fontSize: 11 }}>{r.externalPaypalTxId || "—"}</p></td>
                                            <td className="text-end" style={{ whiteSpace: "nowrap" }}>
                                                {r.status === "requested" && (
                                                    <>
                                                        <button className="pxlCommon-btn pxlCommon-btn--success" style={{ padding: "6px 12px", fontSize: 12, marginRight: 6 }} disabled={busyId === r._id} onClick={() => approve(r)}>Approve</button>
                                                        <button className="pxlCommon-btn pxlCommon-btn--danger" style={{ padding: "6px 12px", fontSize: 12 }} disabled={busyId === r._id} onClick={() => { setRejectPayoutId(r._id); setRejectNotes(""); }}>Reject</button>
                                                    </>
                                                )}
                                                {r.status === "approved" && (
                                                    <button className="pxlCommon-btn" style={{ padding: "6px 12px", fontSize: 12 }} disabled={busyId === r._id} onClick={() => { setMarkPayoutId(r._id); setPaypalTxId(""); setMarkNotes(""); }}>
                                                        Mark paid
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            {markPayoutId && (
                <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Mark payout as paid</h5>
                                <button className="btn-close" onClick={() => setMarkPayoutId(null)}></button>
                            </div>
                            <div className="modal-body">
                                <p className="text-muted small">Send the funds via PayPal first, then paste the transaction id below to record the payout.</p>
                                <div className="mb-3">
                                    <label className="form-label">External PayPal transaction id</label>
                                    <input className="form-control" value={paypalTxId} onChange={e => setPaypalTxId(e.target.value)} required />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Notes (optional)</label>
                                    <textarea className="form-control" rows="2" value={markNotes} onChange={e => setMarkNotes(e.target.value)} />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-light" onClick={() => setMarkPayoutId(null)}>Cancel</button>
                                <button className="btn btn-primary" disabled={busyId === markPayoutId} onClick={submitMarkPaid}>
                                    {busyId === markPayoutId ? "Saving…" : "Mark as paid"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {rejectPayoutId && (
                <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Reject payout</h5>
                                <button className="btn-close" onClick={() => setRejectPayoutId(null)}></button>
                            </div>
                            <div className="modal-body">
                                <p className="text-muted small">Bundled commissions will be released back to <code>available</code> so the affiliate can request again.</p>
                                <div className="mb-3">
                                    <label className="form-label">Reason / notes</label>
                                    <textarea className="form-control" rows="3" value={rejectNotes} onChange={e => setRejectNotes(e.target.value)} />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-light" onClick={() => setRejectPayoutId(null)}>Cancel</button>
                                <button className="btn btn-danger" disabled={busyId === rejectPayoutId} onClick={submitReject}>
                                    {busyId === rejectPayoutId ? "Saving…" : "Reject"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
